export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7438.fac7a242.jpg";